// Thin fetch wrapper. Every mutating call carries X-Harness (CSRF guard on the server).
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public code?: string,
  ) {
    super(message);
  }
}

async function call<T>(method: string, path: string, body?: unknown): Promise<T> {
  const r = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers: { ...(body !== undefined ? { 'content-type': 'application/json' } : {}), 'x-harness': '1' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const text = await r.text();
  let data: unknown = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!r.ok) {
    const d = data as { error?: string; code?: string } | null;
    if (r.status === 401 && !path.startsWith('/api/auth/')) window.dispatchEvent(new Event('harness:unauthorized'));
    throw new ApiError(r.status, d?.error ?? `Request failed (${r.status})`, d?.code);
  }
  return data as T;
}

export const api = {
  get: <T>(p: string) => call<T>('GET', p),
  post: <T>(p: string, b: unknown = {}) => call<T>('POST', p, b),
  put: <T>(p: string, b: unknown) => call<T>('PUT', p, b),
  patch: <T>(p: string, b: unknown) => call<T>('PATCH', p, b),
  del: <T>(p: string, b?: unknown) => call<T>('DELETE', p, b),
};

export function errorText(e: unknown): string {
  return e instanceof Error ? e.message : 'Something went wrong';
}

/** Triggers a browser download of an API endpoint (export). */
export function download(path: string) {
  const a = document.createElement('a');
  a.href = path;
  a.download = '';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
